/**
 * ═══════════════════════════════════════════════════════════════════════
 * ЭТОТ ФАЙЛ СОБРАН, А НЕ НАПИСАН.
 *
 * `K` — имена классов частиц кабинета. Сами правила лежат рядом,
 * в `atoms.css`: их читает сборка, а не разметка. Карта имён —
 * tools/kabinet-atoms.map.mjs, сборщик — tools/gen-kabinet-atoms.mjs,
 * сторож — src/kabinet/atoms.spec.ts.
 *
 * ПРАВИТЬ РУКАМИ НЕЛЬЗЯ. Правка — в эталоне или в карте.
 * ═══════════════════════════════════════════════════════════════════════
 */
export const K = {
  остатокТарифа: "k-остаток-тарифа",
  точкаОстатка: "k-точка-остатка",
  выборКабинета: "k-выбор-кабинета",
  имяВыбораКабинета: "k-имя-выбора-кабинета",
  счётВыбораКабинета: "k-счёт-выбора-кабинета",
  разделВШапке: "k-раздел-в-шапке",
  кнопкаПоддержки: "k-кнопка-поддержки",
  счётчикНаЗначке: "k-счётчик-на-значке",
  кнопкаПрофиля: "k-кнопка-профиля",
  кружокПрофиля: "k-кружок-профиля",
  шапкаЭкрана: "k-шапка-экрана",
  столбикЗаголовка: "k-столбик-заголовка",
  заголовокЭкрана: "k-заголовок-экрана",
  подписьЭкрана: "k-подпись-экрана",
  рядДействийЭкрана: "k-ряд-действий-экрана",
  родКампании: "k-род-кампании",
  площадкаКампании: "k-площадка-кампании",
  рядОтбора: "k-ряд-отбора",
  уПоляПоиска: "k-у-поля-поиска",
  значокПоиска: "k-значок-поиска",
  шапкаКабинета: "k-шапка-кабинета",
  кнопкаРазделы: "k-кнопка-разделы",
  кнопкаУведомлений: "k-кнопка-уведомлений",
  полосаПредупреждения: "k-полоса-предупреждения",
  текстПредупреждения: "k-текст-предупреждения",
  кнопкаЗакрытьПредупреждение: "k-кнопка-закрыть-предупреждение",
  отборСостояний: "k-отбор-состояний",
  чипОтбора: "k-чип-отбора",
  чипОтбораВыбран: "k-чип-отбора-выбран",
  плиткиПоказателей: "k-плитки-показателей",
  полеПоиска: "k-поле-поиска",
  ячейкаБюджета: "k-ячейка-бюджета",
  значокВБюджете: "k-значок-в-бюджете",
  полосаИтогов: "k-полоса-итогов",
  итогиПериода: "k-итоги-периода",
  таблицаКампаний: "k-таблица-кампаний",
  строкаКампании: "k-строка-кампании",
  имяКампании: "k-имя-кампании",
  кнопкаПериода: "k-кнопка-периода",
  кнопкаСинхронизации: "k-кнопка-синхронизации",
  кнопкаКолонок: "k-кнопка-колонок",
  кнопкаЗавершить: "k-кнопка-завершить",
  кнопкаРазбора: "k-кнопка-разбора",
  тумблерПоказов: "k-тумблер-показов",
  кнопкаСвернутьПоказатели: "k-кнопка-свернуть-показатели",
  сппТовара: "k-спп-товара",
  словоСпп: "k-слово-спп",
  запасТовара: "k-запас-товара",
  меткиТестов: "k-метки-тестов",
  меткаТестаСтавки: "k-метка-теста-ставки",
  меткаТестаФото: "k-метка-теста-фото",
  выборГруппы: "k-выбор-группы",
  имяВыбораГруппы: "k-имя-выбора-группы",
  счётВыбораГруппы: "k-счёт-выбора-группы",
  менюКабинетов: "k-меню-кабинетов",
  строкаКабинетаВМеню: "k-строка-кабинета-в-меню",
  имяКабинетаВМеню: "k-имя-кабинета-в-меню",
  состояниеКлюча: "k-состояние-ключа",
  точкаКлюча: "k-точка-ключа",
  подписьМенюКабинетов: "k-подпись-меню-кабинетов",
  кнопкаДобавитьКабинет: "k-кнопка-добавить-кабинет",
  кнопкаПродлитьТариф: "k-кнопка-продлить-тариф",
  менюПрофиля: "k-меню-профиля",
  пунктПрофиля: "k-пункт-профиля",
  значокПунктаПрофиля: "k-значок-пункта-профиля",
  шапкаПрофиля: "k-шапка-профиля",
  кружокПрофиляКрупный: "k-кружок-профиля-крупный",
  почтаПрофиля: "k-почта-профиля",
  чертаПрофиля: "k-черта-профиля",
  пунктВыйти: "k-пункт-выйти",
  кнопкаПрофиляОткрыта: "k-кнопка-профиля-открыта",
  подложкаМеню: "k-подложка-меню",
  ящикМеню: "k-ящик-меню",
  шапкаЯщикаМеню: "k-шапка-ящика-меню",
  столбикВЯщикеМеню: "k-столбик-в-ящике-меню",
  кабинетВЯщикеМеню: "k-кабинет-в-ящике-меню",
  кнопкаЗакрытьМеню: "k-кнопка-закрыть-меню",
  подвалМеню: "k-подвал-меню",
  кнопкаТемыВМеню: "k-кнопка-темы-в-меню",
  кнопкаВыйтиВМеню: "k-кнопка-выйти-в-меню",
  разделыМеню: "k-разделы-меню",
  пунктМеню: "k-пункт-меню",
  пунктМенюТекущий: "k-пункт-меню-текущий",
  значокРаздела: "k-значок-раздела",
  значокРазделаТекущий: "k-значок-раздела-текущий",
  меткаСкоро: "k-метка-скоро",
  подписьГруппыМеню: "k-подпись-группы-меню",
  подписьГруппыМенюДалее: "k-подпись-группы-меню-далее",
  чертаГруппыМеню: "k-черта-группы-меню",
  группаМеню: "k-группа-меню",
  колонкаПункта: "k-колонка-пункта",
  рядПункта: "k-ряд-пункта",
  названиеПункта: "k-название-пункта",
  названиеПунктаТекущее: "k-название-пункта-текущее",
  названиеПунктаСкоро: "k-название-пункта-скоро",
  подписьПункта: "k-подпись-пункта",
  подписьПунктаТекущая: "k-подпись-пункта-текущая",
  столбикКлюча: "k-столбик-ключа",
  логоПодключения: "k-лого-подключения",
  значокЛогоПодключения: "k-значок-лого-подключения",
  имяЛогоПодключения: "k-имя-лого-подключения",
  кнопкаВыйтиПодключение: "k-кнопка-выйти-подключение",
  шапкаПодключения: "k-шапка-подключения",
  заголовокПодключения: "k-заголовок-подключения",
  поясненияПодключения: "k-пояснения-подключения",
  шагиКлюча: "k-шаги-ключа",
  шагКлюча: "k-шаг-ключа",
  номерШагаКлюча: "k-номер-шага-ключа",
  столбикШагаКлюча: "k-столбик-шага-ключа",
  названиеШагаКлюча: "k-название-шага-ключа",
  подписьШагаКлюча: "k-подпись-шага-ключа",
  полеКлюча: "k-поле-ключа",
  столбикПоляКлюча: "k-столбик-поля-ключа",
  названиеПоляКлюча: "k-название-поля-ключа",
  вводКлюча: "k-ввод-ключа",
  подписьПоляКлюча: "k-подпись-поля-ключа",
  рядКнопокКлюча: "k-ряд-кнопок-ключа",
  кнопкаПроверитьКлюч: "k-кнопка-проверить-ключ",
  подключитьПозже: "k-подключить-позже",
  чтоДальшеКлюч: "k-что-дальше-ключ",
  подписьЧтоДальше: "k-подпись-что-дальше",
  строкаЧтоДальше: "k-строка-что-дальше",
  названиеЧтоДальше: "k-название-что-дальше",
  подписьСтрокиЧтоДальше: "k-подпись-строки-что-дальше",
  кнопкаПроверитьКлючГотова: "k-кнопка-проверить-ключ-готова",
  значокПроверкиБеда: "k-значок-проверки-беда",
  названиеПроверкиБеда: "k-название-проверки-беда",
  значокПроверкиНет: "k-значок-проверки-нет",
  прочеркПроверки: "k-прочерк-проверки",
  названиеПроверкиНет: "k-название-проверки-нет",
  отказКлюча: "k-отказ-ключа",
  названиеОтказаКлюча: "k-название-отказа-ключа",
  подписьОтказаКлюча: "k-подпись-отказа-ключа",
  шагиОтказаКлюча: "k-шаги-отказа-ключа",
  проверкиКлюча: "k-проверки-ключа",
  проверкаКлюча: "k-проверка-ключа",
  значокПроверкиОк: "k-значок-проверки-ок",
  названиеПроверкиОк: "k-название-проверки-ок",
  столбикПроверки: "k-столбик-проверки",
  подписьПроверки: "k-подпись-проверки",
  ключПринят: "k-ключ-принят",
  столбикПринят: "k-столбик-принят",
  названиеПринят: "k-название-принят",
  подписьПринят: "k-подпись-принят",
  кнопкаОткрытьБиддер: "k-кнопка-открыть-биддер",
  столбикПриложения: "k-столбик-приложения",
  шапкаПриложения: "k-шапка-приложения",
  заголовокПриложения: "k-заголовок-приложения",
  поясненияПриложения: "k-пояснения-приложения",
  выборТелефона: "k-выбор-телефона",
  кнопкаТелефона: "k-кнопка-телефона",
  кнопкаТелефонаВыбрана: "k-кнопка-телефона-выбрана",
  шагиПриложения: "k-шаги-приложения",
  шагПриложения: "k-шаг-приложения",
  номерШага: "k-номер-шага",
  столбикШага: "k-столбик-шага",
  названиеШага: "k-название-шага",
  подписьШага: "k-подпись-шага",
  подсказкаАйфон: "k-подсказка-айфон",
  значокПодсказкиАйфон: "k-значок-подсказки-айфон",
  чтоДаётПриложение: "k-что-даёт-приложение",
  подписьЧтоДаёт: "k-подпись-что-даёт",
  строкаЧтоДаёт: "k-строка-что-даёт",
  названиеЧтоДаёт: "k-название-что-даёт",
  подписьЧтоДаётНиз: "k-подпись-что-даёт-низ",
  подписьСтрокиЧтоДаёт: "k-подпись-строки-что-даёт",
  подсказкаАндроид: "k-подсказка-андроид",
  значокПодсказкиАндроид: "k-значок-подсказки-андроид",
  меткаЦели: "k-метка-цели",
  рядСГруппами: "k-ряд-с-группами",
  колонкаГрупп: "k-колонка-групп",
  шапкаКолонкиГрупп: "k-шапка-колонки-групп",
  названиеКолонкиГрупп: "k-название-колонки-групп",
  счётКолонкиГрупп: "k-счёт-колонки-групп",
  кнопкаСвернутьГруппы: "k-кнопка-свернуть-группы",
  рядПоискаГрупп: "k-ряд-поиска-групп",
  поискГрупп: "k-поиск-групп",
  списокГрупп: "k-список-групп",
  строкаГруппыВыбрана: "k-строка-группы-выбрана",
  именаГруппыВыбрана: "k-имена-группы-выбрана",
  счётГруппыВыбран: "k-счёт-группы-выбран",
  строкаГруппыВКолонке: "k-строка-группы-в-колонке",
  счётГруппы: "k-счёт-группы",
  подвалКолонкиГрупп: "k-подвал-колонки-групп",
  кнопкаНоваяГруппа: "k-кнопка-новая-группа",
  кнопкаНастроитьГруппы: "k-кнопка-настроить-группы",
  меткаГруппы: "k-метка-группы",
  строкаСостояния: "k-строка-состояния",
  пределРяд: "k-предел-ряд",
  подписьПредела: "k-подпись-предела",
  числоПредела: "k-число-предела",
  полоскаПредела: "k-полоска-предела",
  заполнениеПредела: "k-заполнение-предела",
  значокВыгрузки: "k-значок-выгрузки",
  шапкаКампании: "k-шапка-кампании",
  вкладкиКампании: "k-вкладки-кампании",
  вкладкаКампании: "k-вкладка-кампании",
  вкладкаКампанииТихая: "k-вкладка-кампании-тихая",
  панельВозможностей: "k-панель-возможностей",
  возможность: "k-возможность",
  строкаИмениВозможности: "k-строка-имени-возможности",
  имяВозможности: "k-имя-возможности",
  словоВозможности: "k-слово-возможности",
  тумблерВозможности: "k-тумблер-возможности",
  тумблерВозможностиВыкл: "k-тумблер-возможности-выкл",
  рядЗначенияВозможности: "k-ряд-значения-возможности",
  значениеВозможности: "k-значение-возможности",
  рядПодсказкиВозможности: "k-ряд-подсказки-возможности",
  подсказкаВозможности: "k-подсказка-возможности",
  шестерёнкаВозможности: "k-шестерёнка-возможности",
  подписьПанелиТоваров: "k-подпись-панели-товаров",
  полеСтавкиТовара: "k-поле-ставки-товара",
  тумблерКампании: "k-тумблер-кампании",
  кнопкаЗавершитьКампанию: "k-кнопка-завершить-кампанию",
  счётКампании: "k-счёт-кампании",
  остатокКампании: "k-остаток-кампании",
  подписьСчётаВШапке: "k-подпись-счёта-в-шапке",
  значокСчёта: "k-значок-счёта",
  площадкиКампании: "k-площадки-кампании",
  подписьПлощадок: "k-подпись-площадок",
  капсулаПлощадки: "k-капсула-площадки",
  кнопкаСвернутьНастройки: "k-кнопка-свернуть-настройки",
  сппКампании: "k-спп-кампании",
  числоСппКампании: "k-число-спп-кампании",
  запасШапки: "k-запас-шапки",
  точкаЗапаса: "k-точка-запаса",
  подложкаОкна: "k-подложка-окна",
  окноЦелей: "k-окно-целей",
  шапкаОкнаЦелей: "k-шапка-окна-целей",
  названиеОкнаЦелей: "k-название-окна-целей",
  подписьОкнаЦелей: "k-подпись-окна-целей",
  кнопкаЗакрытьЦели: "k-кнопка-закрыть-цели",
  телоОкнаЦелей: "k-тело-окна-целей",
  поясненияЦелей: "k-пояснения-целей",
  блокЦели: "k-блок-цели",
  рядНазванияЦели: "k-ряд-названия-цели",
  названиеЦели: "k-название-цели",
  подписьЦели: "k-подпись-цели",
  рядПоляЦели: "k-ряд-поля-цели",
  уПоляЦели: "k-у-поля-цели",
  полеЦелиДрр: "k-поле-цели-дрр",
  знакПоляЦели: "k-знак-поля-цели",
  кнопкаВзятьПредложенное: "k-кнопка-взять-предложенное",
  цельИзИстории: "k-цель-из-истории",
  ступениЦели: "k-ступени-цели",
  ступеньЦели: "k-ступень-цели",
  ступеньЦелиГрань: "k-ступень-цели-грань",
  ступеньЦелиСливает: "k-ступень-цели-сливает",
  имяСтупениРаботает: "k-имя-ступени-работает",
  имяСтупениГрань: "k-имя-ступени-грань",
  имяСтупениСливает: "k-имя-ступени-сливает",
  пределСтупени: "k-предел-ступени",
  блокЦеныЗаказа: "k-блок-цены-заказа",
  переключательЦены: "k-переключатель-цены",
  кнопкаРежимаЦены: "k-кнопка-режима-цены",
  кнопкаРежимаЦеныВыбрана: "k-кнопка-режима-цены-выбрана",
  полеЦелиЗаказа: "k-поле-цели-заказа",
  подписьРасчётаЦены: "k-подпись-расчёта-цены",
  низОкнаЦелей: "k-низ-окна-целей",
  поясненияМалоКликов: "k-пояснения-мало-кликов",
  галочкаВПравила: "k-галочка-в-правила",
  квадратикВПравила: "k-квадратик-в-правила",
  столбикГалочки: "k-столбик-галочки",
  названиеГалочки: "k-название-галочки",
  подписьГалочки: "k-подпись-галочки",
  подвалОкнаЦелей: "k-подвал-окна-целей",
  приписьПодвалаЦелей: "k-припись-подвала-целей",
  кнопкаОтменыЦелей: "k-кнопка-отмены-целей",
  кнопкаСохранитьЦели: "k-кнопка-сохранить-цели",
  кнопкаСохранитьРасписание: "k-кнопка-сохранить-расписание",
  сеткаПоказов: "k-сетка-показов",
  клеткаСетки: "k-клетка-сетки",
  разгонПередОкном: "k-разгон-перед-окном",
  подписьКартыЧасов: "k-подпись-карты-часов",
  картаЧасов: "k-карта-часов",
  сборСеткиПоЗаказам: "k-сбор-сетки-по-заказам",
  полеСтавкиЗапроса: "k-поле-ставки-запроса",
  кнопкаТестаСтавки: "k-кнопка-теста-ставки",
  кнопкаПрименитьСтавку: "k-кнопка-применить-ставку",
  подложкаОкнаСтавки: "k-подложка-окна-ставки",
  окноСтавки: "k-окно-ставки",
  шапкаОкнаСтавки: "k-шапка-окна-ставки",
  названиеОкнаСтавки: "k-название-окна-ставки",
  подписьОкнаСтавки: "k-подпись-окна-ставки",
  кнопкаЗакрытьСтавку: "k-кнопка-закрыть-ставку",
  вкладкиОкнаСтавки: "k-вкладки-окна-ставки",
  вкладкаСтавкиВыбрана: "k-вкладка-ставки-выбрана",
  вкладкаСтавки: "k-вкладка-ставки",
  телоОкнаСтавки: "k-тело-окна-ставки",
  рядСтавки: "k-ряд-ставки",
  меткаСтавки: "k-метка-ставки",
  органСтавки: "k-орган-ставки",
  кнопкаМеньшеСтавки: "k-кнопка-меньше-ставки",
  вводСтавки: "k-ввод-ставки",
  кнопкаБольшеСтавки: "k-кнопка-больше-ставки",
  подсказкиСтавки: "k-подсказки-ставки",
  оговоркаСтавки: "k-оговорка-ставки",
  подвалОкнаСтавки: "k-подвал-окна-ставки",
  кнопкаОтменыСтавки: "k-кнопка-отмены-ставки",
  кнопкаСохранитьСтавку: "k-кнопка-сохранить-ставку",
  кнопкаРазбора390: "k-кнопка-разбора390",
  левоРазбора390: "k-лево-разбора390",
  каретаРазбора390: "k-карета-разбора390",
  правоРазбора390: "k-право-разбора390",
  хорошоРазбора390: "k-хорошо-разбора390",
  плохоРазбора390: "k-плохо-разбора390",
  точкаМеждуПределами: "k-точка-между-пределами",
  сеткаПлитокТелефон: "k-сетка-плиток-телефон",
  плиткаТелефон: "k-плитка-телефон",
  подписьПлиткиТелефон: "k-подпись-плитки-телефон",
  значениеПлиткиТелефон: "k-значение-плитки-телефон",
  кнопкаЕщёПоказатели: "k-кнопка-ещё-показатели",
  карточкаКампании: "k-карточка-кампании",
  верхКарточки: "k-верх-карточки",
  именаКарточки: "k-имена-карточки",
  имяКарточки: "k-имя-карточки",
  рядНомера: "k-ряд-номера",
  номерКарточки: "k-номер-карточки",
  меткаКарточки: "k-метка-карточки",
  рядФото: "k-ряд-фото",
  штКарточки: "k-шт-карточки",
  фотоКарточки: "k-фото-карточки",
  сеткаЧисел: "k-сетка-чисел",
  числоКарточки: "k-число-карточки",
  подписьЧисла: "k-подпись-числа",
  рядКнопокКарточки: "k-ряд-кнопок-карточки",
  кнопкаПодробнее: "k-кнопка-подробнее",
  кнопкаДенегКарточки: "k-кнопка-денег-карточки",
  полосаВыделенного: "k-полоса-выделенного",
  счётВыделенного: "k-счёт-выделенного",
  расходВыделенного: "k-расход-выделенного",
  кнопкиВыделенного: "k-кнопки-выделенного",
  кнопкаВыделенного: "k-кнопка-выделенного",
  кнопкаСнятьВыделение: "k-кнопка-снять-выделение",
  кнопкаВГруппу: "k-кнопка-в-группу",
  менюГрупп: "k-меню-групп",
  списокМенюГрупп: "k-список-меню-групп",
  пунктМенюГрупп: "k-пункт-меню-групп",
  чертаМенюГрупп: "k-черта-меню-групп",
  пунктНоваяГруппа: "k-пункт-новая-группа",
  пунктУбратьИзГруппы: "k-пункт-убрать-из-группы",
  выпадениеГрупп: "k-выпадение-групп",
  списокВыпаденияГрупп: "k-список-выпадения-групп",
  пунктВыпаденияВыбран: "k-пункт-выпадения-выбран",
  счётВыпаденияВыбран: "k-счёт-выпадения-выбран",
  пунктВыпаденияГрупп: "k-пункт-выпадения-групп",
  имяПунктаВыпадения: "k-имя-пункта-выпадения",
  счётПунктаВыпадения: "k-счёт-пункта-выпадения",
  чертаВыпаденияГрупп: "k-черта-выпадения-групп",
  пунктНоваяГруппаВыпадения: "k-пункт-новая-группа-выпадения",
  пунктПоказатьКолонкой: "k-пункт-показать-колонкой",
  окноГрупп: "k-окно-групп",
  шапкаОкнаГрупп: "k-шапка-окна-групп",
  названиеОкнаГрупп: "k-название-окна-групп",
  кнопкаЗакрытьГруппы: "k-кнопка-закрыть-группы",
  телоОкнаГрупп: "k-тело-окна-групп",
  поясненияГрупп: "k-пояснения-групп",
  подвалОкнаГрупп: "k-подвал-окна-групп",
  кнопкаГотовоГруппы: "k-кнопка-готово-группы",
  блокНовойГруппы: "k-блок-новой-группы",
  подписьНовойГруппы: "k-подпись-новой-группы",
  подписьПодПолемГруппы: "k-подпись-под-полем-группы",
  окноГруппСписок: "k-окно-групп-список",
  строкаГруппыВОкне: "k-строка-группы-в-окне",
  полеИмениГруппы: "k-поле-имени-группы",
  счётГруппыВОкне: "k-счёт-группы-в-окне",
  кнопкаУдалитьГруппу: "k-кнопка-удалить-группу",
  полеНовойГруппы: "k-поле-новой-группы",
  кнопкаСоздатьГруппу: "k-кнопка-создать-группу",
  рядНовойГруппы: "k-ряд-новой-группы",
  кнопкаНазад: "k-кнопка-назад",
  итогЗапросов: "k-итог-запросов",
  уВыгрузки: "k-у-выгрузки",
  кнопкаВыгрузки: "k-кнопка-выгрузки",
  менюВыгрузки: "k-меню-выгрузки",
  шапкаМенюВыгрузки: "k-шапка-меню-выгрузки",
  названиеМенюВыгрузки: "k-название-меню-выгрузки",
  форматВыгрузки: "k-формат-выгрузки",
  кнопкаФормата: "k-кнопка-формата",
  кнопкаФорматаВыбрана: "k-кнопка-формата-выбрана",
  вариантВыгрузки: "k-вариант-выгрузки",
  названиеВарианта: "k-название-варианта",
  подписьВарианта: "k-подпись-варианта",
  подписьВыгрузки: "k-подпись-выгрузки",
  счётКОплате: "k-счёт-к-оплате",
  шапкаСчёта: "k-шапка-счёта",
  столбикСчёта: "k-столбик-счёта",
  меткаСчёта: "k-метка-счёта",
  имяСчёта: "k-имя-счёта",
  подписьСчёта: "k-подпись-счёта",
  столбикСуммыСчёта: "k-столбик-суммы-счёта",
  суммаСчёта: "k-сумма-счёта",
  срокСчёта: "k-срок-счёта",
  разборСчёта: "k-разбор-счёта",
  строкаРазбораСчёта: "k-строка-разбора-счёта",
  подписьРазбораСчёта: "k-подпись-разбора-счёта",
  значениеРазбораСчёта: "k-значение-разбора-счёта",
  кнопкаОплатить: "k-кнопка-оплатить",
  подписьОплаты: "k-подпись-оплаты",
  подпискаСейчас: "k-подписка-сейчас",
  столбикПодписки: "k-столбик-подписки",
  надписьПодписки: "k-надпись-подписки",
  имяПодписки: "k-имя-подписки",
  срокПодписки: "k-срок-подписки",
  столбикОстатка: "k-столбик-остатка",
  числоОстаткаПодписки: "k-число-остатка-подписки",
  кнопкаПродлитьПодписку: "k-кнопка-продлить-подписку",
  списокОплатКабинета: "k-список-оплат-кабинета",
  шапкаОплатКабинета: "k-шапка-оплат-кабинета",
  строкаОплатыКабинета: "k-строка-оплаты-кабинета",
  датаОплатыКабинета: "k-дата-оплаты-кабинета",
  суммаОплатыКабинета: "k-сумма-оплаты-кабинета",
  кнопкаЧек: "k-кнопка-чек",
  столбикСборки: "k-столбик-сборки",
  карточкаСборки: "k-карточка-сборки",
  строкаСборки: "k-строка-сборки",
  подписьСборки: "k-подпись-сборки",
  значениеСборки: "k-значение-сборки",
  доводСборки: "k-довод-сборки",
  ссылкаНеНайдено: "k-ссылка-не-найдено",
  подписьНамерений: "k-подпись-намерений",
  списокНамерений: "k-список-намерений",
  когдаНамерение: "k-когда-намерение",
  меткаНамерения: "k-метка-намерения",
  столбикНамерения: "k-столбик-намерения",
  причинаНамерения: "k-причина-намерения",
  доводНамерений: "k-довод-намерений",
  намерение: "k-намерение",
  подписьПравил: "k-подпись-правил",
  правило: "k-правило",
  тумблерПравила: "k-тумблер-правила",
  столбикПравила: "k-столбик-правила",
  рядИмениПравила: "k-ряд-имени-правила",
  меткаПравила: "k-метка-правила",
  меткаДействияПравила: "k-метка-действия-правила",
  условиеПравила: "k-условие-правила",
  итогПравила: "k-итог-правила",
  кнопкиПравила: "k-кнопки-правила",
  кнопкаНовоеПравило: "k-кнопка-новое-правило",
  кнопкаПравитьПравило: "k-кнопка-править-правило",
  кнопкаУдалитьПравило: "k-кнопка-удалить-правило",
  карточкаОплаты: "k-карточка-оплаты",
  верхКарточкиОплаты: "k-верх-карточки-оплаты",
  суммаКарточкиОплаты: "k-сумма-карточки-оплаты",
  датаКарточкиОплаты: "k-дата-карточки-оплаты",
  сводкаКарточкиОплаты: "k-сводка-карточки-оплаты",
  строкаСводкиОплаты: "k-строка-сводки-оплаты",
  подписьСводкиОплаты: "k-подпись-сводки-оплаты",
  значениеСводкиОплаты: "k-значение-сводки-оплаты",
  шапкаПоддержки: "k-шапка-поддержки",
  столбикПоддержки: "k-столбик-поддержки",
  обращение: "k-обращение",
  обращениеТихое: "k-обращение-тихое",
  столбикОбращения: "k-столбик-обращения",
  рядНомераОбращения: "k-ряд-номера-обращения",
  меткаОбращения: "k-метка-обращения",
  номерОбращения: "k-номер-обращения",
  заголовокОбращения: "k-заголовок-обращения",
  строкаОбращения: "k-строка-обращения",
  столбикСрокаОбращения: "k-столбик-срока-обращения",
  когдаОбращение: "k-когда-обращение",
  меткаНовогоОтвета: "k-метка-нового-ответа",
  блокОбращений: "k-блок-обращений",
  подписьМоихОбращений: "k-подпись-моих-обращений",
  переписка: "k-переписка",
  шапкаПереписки: "k-шапка-переписки",
  столбикПереписки: "k-столбик-переписки",
  имяПереписки: "k-имя-переписки",
  подписьПереписки: "k-подпись-переписки",
  меткаПереписки: "k-метка-переписки",
  лентаСообщений: "k-лента-сообщений",
  сообщение: "k-сообщение",
  сообщениеПоддержки: "k-сообщение-поддержки",
  фотоВСообщении: "k-фото-в-сообщении",
  кнопкаОтветитьКабинет: "k-кнопка-ответить-кабинет",
  блокОтвета: "k-блок-ответа",
  полеОтвета: "k-поле-ответа",
  рядОтвета: "k-ряд-ответа",
  кнопкаПриложитьФото: "k-кнопка-приложить-фото",
  кнопкаВопросРешён: "k-кнопка-вопрос-решён",
  кнопкаВПоддержку: "k-кнопка-в-поддержку",
  формаОбращения: "k-форма-обращения",
  названиеФормыОбращения: "k-название-формы-обращения",
  полеОбращения: "k-поле-обращения",
  подписьПоляОбращения: "k-подпись-поля-обращения",
  вводОбращения: "k-ввод-обращения",
  текстОбращения: "k-текст-обращения",
  блокФотоОбращения: "k-блок-фото-обращения",
  рядФотоОбращения: "k-ряд-фото-обращения",
  приложенноеФото: "k-приложенное-фото",
  имяПриложенногоФото: "k-имя-приложенного-фото",
  убратьПриложенноеФото: "k-убрать-приложенное-фото",
  плиткаПриложитьФото: "k-плитка-приложить-фото",
  рядКнопокОбращения: "k-ряд-кнопок-обращения",
  кнопкаОтправитьОбращение: "k-кнопка-отправить-обращение",
  кнопкаОтменыОбращения: "k-кнопка-отмены-обращения",
  кнопкаПериодаОткрыта: "k-кнопка-периода-открыта",
  строкаКампанииВыбрана: "k-строка-кампании-выбрана",
  строкаПлощадкиТовара: "k-строка-площадки-товара",
  строкаДругогоЗаказа: "k-строка-другого-заказа",
  строкаПлощадки390: "k-строка-площадки390",
  другиеЗаказы390: "k-другие-заказы390",
  таблицаЗапросов: "k-таблица-запросов",
  строкаЗапроса: "k-строка-запроса",
  шапкаЗапросов: "k-шапка-запросов",
  галочкаЗапроса: "k-галочка-запроса",
  клеткаЗапроса: "k-клетка-запроса",
  числоЗапроса: "k-число-запроса",
  кнопкаИсключитьЗапрос: "k-кнопка-исключить-запрос",
  кнопкаВернутьЗапрос: "k-кнопка-вернуть-запрос",
  кнопкаИзбранныйЗапрос: "k-кнопка-избранный-запрос",
  прокруткаЗапросов: "k-прокрутка-запросов",
  меткаИзбранного: "k-метка-избранного",
  меткаЧастичноИсключён: "k-метка-частично-исключён",
  меткаИсключён: "k-метка-исключён",
  меткаЧёрногоСписка: "k-метка-чёрного-списка",
  карточкаЗапроса: "k-карточка-запроса",
  имяЗапроса390: "k-имя-запроса390",
  числаЗапроса390: "k-числа-запроса390",
  действияЗапроса390: "k-действия-запроса390",
  экранВхода: "k-экран-входа",
  столбикВхода: "k-столбик-входа",
  знакВхода: "k-знак-входа",
  меткаВхода: "k-метка-входа",
  словоВхода: "k-слово-входа",
  формаВхода: "k-форма-входа",
  заголовокВхода: "k-заголовок-входа",
  именаВхода: "k-имена-входа",
  подписьВхода: "k-подпись-входа",
  полеВхода: "k-поле-входа",
  вводВхода: "k-ввод-входа",
  кнопкаВойти: "k-кнопка-войти",
  рядВхода: "k-ряд-входа",
  ссылкаВхода: "k-ссылка-входа",
  подвалВхода: "k-подвал-входа",
  ссылкаПодвалаВхода: "k-ссылка-подвала-входа",
  экранПриглашения: "k-экран-приглашения",
  шапкаПриглашения: "k-шапка-приглашения",
  знакПриглашения: "k-знак-приглашения",
  меткаПриглашения: "k-метка-приглашения",
  правоПриглашения: "k-право-приглашения",
  столбикКабинетов: "k-столбик-кабинетов",
  логоКабинетов: "k-лого-кабинетов",
  имяЛогоКабинетов: "k-имя-лого-кабинетов",
  кнопкаВыйтиКабинеты: "k-кнопка-выйти-кабинеты",
  шапкаКабинетов: "k-шапка-кабинетов",
  заголовокКабинетов: "k-заголовок-кабинетов",
  подписьКабинетов: "k-подпись-кабинетов",
  сеткаКабинетов: "k-сетка-кабинетов",
  подвалКабинетов: "k-подвал-кабинетов",
  карточкаКабинета: "k-карточка-кабинета",
  кнопкаВыбратьКабинет: "k-кнопка-выбрать-кабинет",
  рядИмениКабинета: "k-ряд-имени-кабинета",
  значокКабинета: "k-значок-кабинета",
  столбикИмениКабинета: "k-столбик-имени-кабинета",
  имяКабинета: "k-имя-кабинета",
  маркаКабинета: "k-марка-кабинета",
  номерКабинета: "k-номер-кабинета",
  меткаВыгрузки: "k-метка-выгрузки",
  меткаВыгрузкиДавно: "k-метка-выгрузки-давно",
  меткаВыгрузкиНикогда: "k-метка-выгрузки-никогда",
  состояниеКлючаКарточки: "k-состояние-ключа-карточки",
  состояниеКлючаСкоро: "k-состояние-ключа-скоро",
  состояниеКлючаБеда: "k-состояние-ключа-беда",
  точкаКлючаКарточки: "k-точка-ключа-карточки",
  точкаКлючаСкоро: "k-точка-ключа-скоро",
  точкаКлючаБеда: "k-точка-ключа-беда",
  целиКабинета: "k-цели-кабинета",
  кнопкаИзменитьЦели: "k-кнопка-изменить-цели",
  рядОбновитьКлюч: "k-ряд-обновить-ключ",
  кнопкаОбновитьКлюч: "k-кнопка-обновить-ключ",
  карточкаПодключить: "k-карточка-подключить",
  рядПодключить: "k-ряд-подключить",
  значокПодключить: "k-значок-подключить",
  подписьПодключить: "k-подпись-подключить",
  требованияПароля: "k-требования-пароля",
  надписьТребований: "k-надпись-требований",
  строкаТребованияГотово: "k-строка-требования-готово",
  строкаТребованияЖдёт: "k-строка-требования-ждёт",
  полеПароля: "k-поле-пароля",
  подписьПоляПароля: "k-подпись-поля-пароля",
  кнопкаОтменаПароля: "k-кнопка-отмена-пароля",
  рядКнопокПароля: "k-ряд-кнопок-пароля",
  ошибкаПовтора: "k-ошибка-повтора",
  полеПароляСОшибкой: "k-поле-пароля-с-ошибкой",
  кнопкаСохранитьПароль: "k-кнопка-сохранить-пароль",
  пусто: "k-пусто",
  знакПусто: "k-знак-пусто",
  причинаПусто: "k-причина-пусто",
  кнопкаПусто: "k-кнопка-пусто",
  числоНеНайдено: "k-число-не-найдено",
  заголовокНеНайдено: "k-заголовок-не-найдено",
  поясНеНайдено: "k-пояс-не-найдено",
  кнопкиНеНайдено: "k-кнопки-не-найдено",
  кнопкаККампаниям: "k-кнопка-к-кампаниям",
  кнопкаКСборке: "k-кнопка-к-сборке",
  отказ: "k-отказ",
  меткаОтказа: "k-метка-отказа",
  заголовокОтказа: "k-заголовок-отказа",
  причинаОтказа: "k-причина-отказа",
  кнопкаОтказа: "k-кнопка-отказа",
  состояниеГрузится: "k-состояние-грузится",
  рядГрузится: "k-ряд-грузится",
  значокГрузится: "k-значок-грузится",
  полосаГрузится: "k-полоса-грузится",
  хвостГрузится: "k-хвост-грузится",
  плашкаУведомления: "k-плашка-уведомления",
  карточкаУведомления: "k-карточка-уведомления",
  значокУведомления: "k-значок-уведомления",
  текстУведомления: "k-текст-уведомления",
  крестикУведомления: "k-крестик-уведомления",
  плашкаЦели: "k-плашка-цели",
  столбикПлашкиЦели: "k-столбик-плашки-цели",
  заголовокПлашкиЦели: "k-заголовок-плашки-цели",
  подписьПлашкиЦели: "k-подпись-плашки-цели",
  кнопкиПлашкиЦели: "k-кнопки-плашки-цели",
  кнопкаПринятьЦель: "k-кнопка-принять-цель",
  кнопкаНастроитьЦель: "k-кнопка-настроить-цель",
  меткаЦелиНеЗадана: "k-метка-цели-не-задана",
  числоПределаТревога: "k-число-предела-тревога",
  заполнениеПределаТревога: "k-заполнение-предела-тревога",
  кнопкаПоднятьТариф: "k-кнопка-поднять-тариф",
  меткаОтбораГруппы: "k-метка-отбора-группы",
  крестикОтбораГруппы: "k-крестик-отбора-группы",
  пустоГруппы: "k-пусто-группы",
  причинаПустойГруппы: "k-причина-пустой-группы",
  выборГруппыВыбран: "k-выбор-группы-выбран",
  пустоБезКлюча: "k-пусто-без-ключа",
  заголовокБезКлюча: "k-заголовок-без-ключа",
  причинаБезКлюча: "k-причина-без-ключа",
  кнопкаПодключитьКабинет: "k-кнопка-подключить-кабинет",
  подсказкаБезКлюча: "k-подсказка-без-ключа",
  капсулаПлощадкиПогашена: "k-капсула-площадки-погашена",
  полосаПоказателей: "k-полоса-показателей",
  кнопкаРазвернутьПоказатели: "k-кнопка-развернуть-показатели",
  полосаВозможностей: "k-полоса-возможностей",
  капсулаВозможности: "k-капсула-возможности",
  кнопкаРазвернутьНастройки: "k-кнопка-развернуть-настройки",
  панельТестаФото: "k-панель-теста-фото",
  строкаТестаФото: "k-строка-теста-фото",
  снимокФото: "k-снимок-фото",
  замерыФото: "k-замеры-фото",
  плиткаФото: "k-плитка-фото",
  кнопкаПоставитьФото: "k-кнопка-поставить-фото",
  окноТестаФото: "k-окно-теста-фото",
  слотыФото: "k-слоты-фото",
  слотФото: "k-слот-фото",
  выборСрокаФото: "k-выбор-срока-фото",
  выборКруговФото: "k-выбор-кругов-фото",
  расчётТестаФото: "k-расчёт-теста-фото",
  кнопкаЗапуститьТестФото: "k-кнопка-запустить-тест-фото",
  счётТестовФото: "k-счёт-тестов-фото",
  слотФотоПустой: "k-слот-фото-пустой",
  строкаЗамераФото: "k-строка-замера-фото",
  миниатюраЗамера: "k-миниатюра-замера",
  строкаИсторииФото: "k-строка-истории-фото",
  пустоБезТестаФото: "k-пусто-без-теста-фото",
  счётТестовСтавки: "k-счёт-тестов-ставки",
} as const;

export type KabAtom = keyof typeof K;
